<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row mt-3">
        <div class="col-12">
          <card class="strpied-tabled-with-hover"
                body-classes="table-full-width table-responsive"
          >
            <template slot="header">
              <b-row>
              <b-col lg="3">
                <label for="datepicker-invalid">Date From</label>
                <b-form-datepicker v-model="DateFrom" id="datepicker-invalid" locale="en-US" size="sm"></b-form-datepicker>
              </b-col>
              <b-col lg="3">
                <label for="datepicker-invalid2">Date To</label>
                <b-form-datepicker v-model="DateTo" id="datepicker-invalid2" locale="en-US" size="sm"></b-form-datepicker>
              </b-col>
              <b-col lg="2" class="mt-4">
                <b-button class="btn-secondary" id="datepicker-btn" @click="getPaymentsByOwnerIDAndDate()">Find</b-button>
              </b-col>
              <b-col lg="1" class="mt-4">
                <b-button-toolbar key-nav aria-label="Toolbar with button groups">
                  <b-button-group class="mx-1">
                    <b-button style="padding: 5px 6px !important;" @click="getDataForExcel()" title="Export to excel"><b-icon icon="file-earmark-excel-fill"></b-icon></b-button>
                    <b-button style="padding: 5px 6px !important;" @click="getDataForPDF()" title="Export to Pdf"><b-icon icon="file-earmark-pdf-fill"></b-icon></b-button>
                  </b-button-group>
                </b-button-toolbar>
              </b-col>
             <b-col lg="3" class="my-1">
              <label for="datepicker-invalid3"></label>
                  <b-form-group class="mb-0" id="datepicker-invalid3">
                    <b-input-group size="sm">
                      <b-form-input
                        id="filter-input"
                        v-model="filter"
                        type="search"
                        placeholder="Filter"
                      ></b-form-input>
                      <b-input-group-append>
                        <b-button class="btn-secondary" :disabled="!filter" @click="filter = ''"
                          >Clear</b-button
                        >
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
             </b-col>
              </b-row>
            </template>
            <div class="table-container">
            <b-table-simple
              :small="true"
              sticky-header
              style="max-height: 395px;"
              striped
              responsive
              hover
            >
              <b-thead>
                <b-tr>
                  <b-th>No.</b-th>
                  <b-th>Tenant</b-th>
                  <b-th>Tenant Phone No</b-th>
                  <b-th>Building</b-th>
                  <b-th>House</b-th>
                  <b-th>Total Amount</b-th>
                  <b-th>Paid Amount</b-th>
                  <b-th>15% VAT</b-th>
                  <b-th>3% Withholding</b-th>
                  <b-th>Paid For</b-th>
                  <b-th>Paid Month</b-th>
                  <b-th>Payment Method</b-th>
                  <b-th>Date of Payment</b-th>
                  <b-th>Credit Account</b-th>
                  <b-th>Transaction Reference</b-th>
                </b-tr>
              </b-thead>
              <template v-if="spinner">
                  <b-tbody class="text-center">
                    <b-tr >
                        <b-td colspan="11" class="text-center" style="display: table-cell">
                          <b-spinner
                          style="height: 3rem; width: 3rem;"
                            variant="warning"
                          ></b-spinner>
                        </b-td>
                      </b-tr>
                  </b-tbody>
                </template>
              <template v-else>
                <b-tbody>
                  <template v-if="filterTable.length === 0">
                      <b-tr>
                        <b-td colspan="9" class="text-center">Nothing found</b-td>
                        <b-td></b-td>
                      </b-tr>
                  </template>
                  <template v-else>
                  <b-tr
                    v-for="(item, index) in filterTable"
                    :key="item.ID"
                  >
                      <b-td>{{(currentPage - 1) * perPage + index + 1}}</b-td>
                      <b-td>{{item.tenant.fullName}}</b-td>
                      <b-td>{{item.tenantPhoneNumber}}</b-td>
                      <b-td>{{item.house.building.buildingName}}</b-td>
                      <b-td>{{item.house.floor}} - {{item.house.roomNumber}}</b-td>
                      <b-td>{{numberWithCommas(item.totalAmount)}}</b-td>
                      <b-td>{{numberWithCommas(item.payedAmount)}}</b-td>
                      <b-td>
                       <template v-if="item.paymentCategory === 'Rent Payment'">
                        {{numberWithCommas(item.vat)}}
                        </template>
                        <template v-else>
                          0
                        </template>
                      </b-td>
                      <b-td>{{numberWithCommas(item.withHolding)}}</b-td>
                      <b-td>{{item.paymentCategory}}</b-td>
                      <b-td>{{item.paymentForMonth}}</b-td>
                      <b-td>{{item.paymentMethod}}</b-td>
                      <b-td>{{item.paymentDate}}</b-td>
                      <b-td>{{item.creditAccount}}</b-td>
                      <b-td>{{item.transactionRef}}</b-td>
                  </b-tr>
                  </template>
                </b-tbody>
              </template>
            </b-table-simple>
            </div>
            <div class="pagination-container mt-2">
            <b-row>
                    <b-col md="3">
                      <b-form-group
                        id="fieldset-horizontal"
                        label-cols="8" label-cols-xs="8" label-size="md"
                        label="records per page"
                        label-for="input-horizontal"
                        label-align-xl="right"  
                      >
                      <b-form-select id="input-horizontal" v-model="perPage" :options="pageOptions" @change="changePerPage"></b-form-select>
                      </b-form-group>
                    </b-col>
                    <b-col md="9">
                      <b-pagination v-model="currentPage" :per-page="perPage" :total-rows="totalRows" @page-click="changePage" align="right"></b-pagination>
                    </b-col>
                </b-row>
            </div>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import LTable from 'src/components/Table.vue'
  import Card from 'src/components/Cards/Card.vue'
  import jsPDF from 'jspdf'
  import 'jspdf-autotable';
  export default {
    components: {
      LTable,
      Card
    },
    data () {
      return {
        modulePermission: {
          view: 1,
          create: 0,
          update: 0,
          delete: 0
        },
        totalRows: 0,
        currentPage: 1,
        perPage: 7,
        pageOptions: [
          {value: 7, text: 7},
          {value: 10, text: 10},
          {value: 25, text: 25},
          {value: 50, text: 50},
          {value: 100, text: 100}
        ],
        items: [],
        filter: "",
        DateFrom: "",
        DateTo: "",
        spinner: true,
        dataExcel: []
      }
    },
    computed: {
      filterTable() {
        var searchItems = this.items;
        var searchString = this.filter;
        if (searchString === "") {
          return searchItems;
        }
        searchString = searchString.trim().toLowerCase();

        searchItems = searchItems.filter(function (item) {
          if (item.house.building.buildingName.toLowerCase().indexOf(searchString) !== -1 || item.tenant.fullName.toLowerCase().indexOf(searchString) !== -1 || item.tenantPhoneNumber.toLowerCase().indexOf(searchString) !== -1  || (String(item.house.floor).toLowerCase() + " - " + item.house.roomNumber.toLowerCase()).indexOf(searchString) !== -1) {
            return item;
          }
        });
        return searchItems;
      },
    },
     mounted() {
      this.getModules();
      this.getPaymentsByOwnerID();
      this.$on("AfterComplete", () => {
        this.getPaymentsByOwnerID();
      });
    },
    methods: {
//------------------------------

 async getDataForExcel() {
    this.dataExcel = [];
    if (this.DateFrom !== "" && this.DateTo !== "") {
        try {
            const response = await this.$store.dispatch('getPaymentsByOwnerIDAndDate', {
                userId: parseInt(sessionStorage.getItem("ID")),
                startDate: this.DateFrom,
                endDate: this.DateTo,
                page: 1,
                line: this.totalRows
            });

            if (response.data.Contents.length > 0) {
                let index = 0;
                Array.from(response.data.Contents).forEach(x => {
                    index++;
                    this.dataExcel.push({
                        No: index,
                        Tenant_Name: x.tenant.fullName,
                        Tenant_Phone_Number: x.tenantPhoneNumber,
                        Building: x.house.building.buildingName,
                        Floor: x.house.floor,
                        Room_Number:x.house.roomNumber,
                        Total_Amount: x.totalAmount,
                        Paid_Amount: x.payedAmount,
                        Paid_Month: x.paymentForMonth,
                        VAT: x.vat,
                        Withholding: x.withHolding,
                        Paid_For: x.paymentCategory,
                        Payment_Method: x.paymentMethod,
                        Date_of_Payment: x.paymentDate,
                        Credit_Account: x.creditAccount,
                        Transaction_Reference: x.transactionRef
                    });
                });
            }
        } catch (error) {
            this.handleError(error);
        }
    } else {
        try {
            const response = await this.$store.dispatch('getPaymentsByOwnerID', {
                userId: parseInt(sessionStorage.getItem("ID")),
                page: 1,
                line: this.totalRows
            });

            if (response.data.Contents.length > 0) {
                let index = 0;
                Array.from(response.data.Contents).forEach(x => {
                    index++;
                    this.dataExcel.push({
                        No: index,
                        Tenant_Name: x.tenant.fullName,
                        Tenant_Phone_Number: x.tenantPhoneNumber,
                        Building: x.house.building.buildingName,
                        Floor: x.house.floor,
                        Room_Number:x.house.roomNumber,
                        Total_Amount: x.totalAmount,
                        Paid_Amount: x.payedAmount,
                        Paid_Month: x.paymentForMonth,
                        VAT: x.vat,
                        Withholding: x.withHolding,
                        Paid_For: x.paymentCategory,
                        Payment_Method: x.paymentMethod,
                        Date_of_Payment: x.paymentDate,
                        Credit_Account: x.creditAccount,
                        Transaction_Reference: x.transactionRef
                    });
                });
            }
        } catch (error) {
            this.handleError(error);
        }
    }

    if (this.dataExcel.length > 0) {
        const filename = 'Report for Payments.csv';
        const csvData = this.convertToCSV(this.dataExcel);
        const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });

        if (navigator.msSaveBlob) {
            navigator.msSaveBlob(blob, filename);
        } else {
            const link = document.createElement('a');
            if (link.download !== undefined) {
                const url = URL.createObjectURL(blob);
                link.setAttribute('href', url);
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }
    } else {
        this.handleError("Nothing to export");
    }
},

convertToCSV(jsonData) {
    const paragraph = "The exceel file to generate";
    const header = Object.keys(jsonData[0]).join(',');
    const rows = jsonData.map(row => Object.values(row).join(','));
    const numColumns = Object.keys(jsonData[0]).length;
    return `${header}\n${rows.join('\n')}`;
},

handleError(error) {
    this.$notifications.notify({
        message: error.response ? error.response.data : error,
        horizontalAlign: 'center',
        verticalAlign: 'top',
        type: 'danger'
    });
    console.log(error);
},
  async getDataForPDF() {
  this.dataExcel = [];
  this.spinner = true;

  try {
    let response;

    if (this.DateFrom !== "" && this.DateTo !== "") {
      response = await this.$store.dispatch('getPaymentsByOwnerIDAndDate', { userId: parseInt(sessionStorage.getItem("ID")), startDate: this.DateFrom, endDate: this.DateTo, page: 1, line: this.totalRows });
    } else {
      response = await this.$store.dispatch('getPaymentsByOwnerID', { userId: parseInt(sessionStorage.getItem("ID")), page: 1, line: this.totalRows });
    }

    if (response.data.Contents.length > 0) {
      let index = 0;

      response.data.Contents.forEach(x => {
        index++;

        this.dataExcel.push({
          No: index,
          Tenant_Name: x.tenant.fullName,
          Tenant_Phone_Number: x.tenantPhoneNumber,
          Building: x.house.building.buildingName,
          House: x.house.floor+'-'+x.house.roomNumber,
          Total_Amount: x.totalAmount,
          Paid_Amount: x.payedAmount,
          VAT: x.vat,
          Withholding: x.withHolding,
          Paid_For: x.paymentCategory,
          Paid_Month: x.paymentForMonth,
          Payment_Method: x.paymentMethod,
          Date_of_Payment: x.paymentDate,
          Credit_Account: x.creditAccount,
          Transaction_Reference: x.transactionRef
        });
      });

      if (this.dataExcel.length > 0) {
        var pdf = new jsPDF({
          orientation: 'landscape'
        });

        let headers = [
          "No",
          "Tenant Name",
          "Tenant Phone Number",
          "Building",
          "House",
          "Total Amount",
          "Paid Amount",
          "15% VAT",
          "2% Withholding",
          "Payment For",
          "Paid Month",
          "Payment Method",
          "Date of Payment",
          "Credit Account",
          "Transaction Reference"
        ];

        let rows = this.dataExcel.map(obj => Object.values(obj));

        pdf.autoTable({
          head: [headers],
          body: rows,
          styles: {
            fontSize: 6
          },
          headStyles: {
            fillColor: [37, 91, 48],
            textColor: [240, 206, 13],
            fontSize:6.6
          },
        });

        pdf.save("Report_for_Payment.pdf");
      } else {
        this.$notifications.notify({
          message: "No data to export",
          horizontalAlign: 'center',
          verticalAlign: 'top',
          type: 'danger'
        });
      }
    }
  } catch (error) {
    console.log(error);
    this.$notifications.notify({
      message: "An error occurred while generating the PDF",
      horizontalAlign: 'center',
      verticalAlign: 'top',
      type: 'danger'
    });
  } finally {
    this.spinner = false;
  }
},

//---------------------------------

      numberWithCommas(x) {
        if(x !== null && x !== undefined){
            x = x.toFixed(2);
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
      },
      getModules(){
        this.$store.dispatch('getModulesPermission', {userId: sessionStorage.getItem("userID")})
          .then(response=>{
              //this.items = response.data;
              var modulesList = response.data.modules;
              var BuildingModule = modulesList.filter(x=>x.name === "Payment");
              if(BuildingModule !== null){
                this.modulePermission.view = BuildingModule[0].listData;
                this.modulePermission.create = BuildingModule[0].createData;
                this.modulePermission.update = BuildingModule[0].updateData;
                this.modulePermission.delete = BuildingModule[0].deleteData;
              }
          })
          .catch(error=>{
              console.log(error);
          })
      },
      getPaymentsByOwnerID(){
        this.spinner = true;
          this.$store.dispatch('getPaymentsByOwnerID', {userId: parseInt(sessionStorage.getItem("ID")), page: this.currentPage, line: this.perPage})
          .then(response=>{
            //console.log("some", response.data);
              this.items = response.data.Contents;
              this.totalRows = response.data.totalElements;
          })
          .catch(error=>{
              // this.$notify({
              //     title: 'Error',
              //     text: error.response.data,
              //     type: 'error'
              // })
              console.log(error);
          })
          .finally(msg=>{
            this.spinner =false;
          })
      },
      changePage(event, page){
        if(this.DateFrom !== "" && this.DateTo !== ""){
          this.spinner = true;
          this.$store.dispatch('getPaymentsByOwnerIDAndDate', {userId: parseInt(sessionStorage.getItem("ID")), startDate: this.DateFrom, endDate: this.DateTo, page: page, line: this.perPage })
          .then(response=>{
              this.items = response.data.Contents;
              this.totalRows = response.data.totalElements;
          })
          .catch(error=>{
              this.$notifications.notify(
                {
                    message: error.response.data,
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'danger'
                })
              console.log(error);
          })
          .finally(msg=>{
            this.spinner =false;
          })
        }else{
          this.spinner = true;
          this.$store.dispatch('getPaymentsByOwnerID', {userId: parseInt(sessionStorage.getItem("ID")), page: page, line: this.perPage})
          .then(response=>{
              this.items = response.data.Contents;
              this.totalRows = response.data.totalElements;
          })
          .catch(error=>{
             this.$notifications.notify(
                {
                    message: error.response.data,
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'danger'
                })
              console.log(error);
          })
          .finally(msg=>{
            this.spinner =false;
          })
        }
      },
      changePerPage(event){
        if(this.DateFrom !== "" && this.DateTo !== ""){
          this.spinner = true;
          this.$store.dispatch('getPaymentsByOwnerIDAndDate', {userId: parseInt(sessionStorage.getItem("ID")), startDate: this.DateFrom, endDate: this.DateTo, page: this.currentPage, line: this.perPage })
          .then(response=>{
              this.items = response.data.Contents;
              this.totalRows = response.data.totalElements;
          })
          .catch(error=>{
              this.$notifications.notify(
                {
                    message: error.response.data,
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'danger'
                })
              console.log(error);
          })
          .finally(msg=>{
            this.spinner =false;
          })
        }else{
          this.spinner = true;
          this.$store.dispatch('getPaymentsByOwnerID', {userId: parseInt(sessionStorage.getItem("ID")), page: this.currentPage, line: this.perPage})
          .then(response=>{
              this.items = response.data.Contents;
              this.totalRows = response.data.totalElements;
          })
          .catch(error=>{
             this.$notifications.notify(
                {
                    message: error.response.data,
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'danger'
                })
              console.log(error);
          })
          .finally(msg=>{
            this.spinner =false;
          })
        }
      },
      getPaymentsByOwnerIDAndDate(){
        if(this.DateFrom !== "" && this.DateTo !== ""){
          this.spinner = true;
          this.$store.dispatch('getPaymentsByOwnerIDAndDate', {userId: parseInt(sessionStorage.getItem("ID")), startDate: this.DateFrom, endDate: this.DateTo , page: this.currentPage, line: this.perPage })
          .then(response=>{
              this.items = response.data.Contents;
              this.totalRows = response.data.totalElements;
          })
          .catch(error=>{
              this.$notifications.notify(
                {
                    message: error.response.data,
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'danger'
                })
              console.log(error);
          })
          .finally(msg=>{
            this.spinner =false;
          })
        }else{
           this.$notifications.notify(
            {
                message: "Please select date intervals",
                horizontalAlign: 'center',
                verticalAlign: 'top',
                type: 'danger'
            })
        }
      },
      clearData(){
        this.$emit('AfterComplete');
      }
    }
  }
</script>
<style scoped>
.table-container {
  overflow-x: auto;
}
.pagination-container {
  border-top: 1px solid #dee2e6;
  padding-top: 8px;
  background: #fff;
  position: relative;
  z-index: 1;
}
</style>
<style>
.text-warning {
    color: rgba(240, 206, 13, 0.937) !important;
}
</style>
